import React, { useState } from "react";
import { Card, Form, Button, Alert, Container, Spinner, InputGroup } from "react-bootstrap";
import { useAuth } from "../AuthContext";
import { Envelope, ShieldLock } from "react-bootstrap-icons";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);
      await login(email, password);
    } catch (err) {
      setError("Email sau parolă incorectă.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh", backgroundColor: "rgba(253, 255, 254, 0)" }}
    >
      <Card
        className="shadow-lg border-0 rounded-4 p-3"
        style={{ maxWidth: "400px", width: "100%" }}
      >
        <Card.Body>
        <div className="text-center mb-3"><img src="logo512.png" alt="Logo" className="img-fluid" style={{ width: "170px", height: "170px" }} /></div>
          <div className="text-center mb-4">
            
            <h2 className="fw-bold text-success">Situație exploatare</h2>
            <p className="fw-light">Versiunea 1.4.0</p>
          </div>
          {error && (
            <Alert variant="danger" className="small">
              {error}
            </Alert>
          )}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold">Email</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <Envelope size={18} />
                </InputGroup.Text>
                <Form.Control
                  type="email"
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label className="small fw-bold">Parolă</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <ShieldLock size={18} />
                </InputGroup.Text>
                <Form.Control
                  type="password"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
              </InputGroup>
            </Form.Group>
            <Button
              disabled={loading}
              variant="success"
              className="w-100 fw-bold py-2"
              type="submit"
            >
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Accesează platforma"
              )}
            </Button>
            
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Login;
